import {Injectable} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ClientService} from "@app/admin/client.service";
import {UserDetailDialogComponent} from "@app/admin/user-detail-dialog/user-detail-dialog.component";
import {User, UserService} from "@shared/user.service";
import {EMPTY, Observable} from "rxjs";
import {catchError, filter, mergeMap} from "rxjs/operators";

@Injectable({providedIn: 'root' })
export class UserFacade{
    constructor(
        private matDialog: MatDialog,
        private matSnackBar: MatSnackBar,
        private userService: UserService,
        private clientService: ClientService,
    ) {
    }

    public editUser(user: User): Observable<any> {
        const dialog = this.matDialog.open(UserDetailDialogComponent, {
            data: user,
        });
        return dialog
            .afterClosed()
            .pipe(
                filter(Boolean),
                mergeMap((data: any) => {
                    return this.userService.updateUser(user.id, data.name);
                }),
                mergeMap(() => this.clientService.get()),
                catchError((err) => {
                    this.matSnackBar.open(err.error.detail ?? 'Error', undefined, {
                        duration: 2000,
                        panelClass: ['error-snackbar'],
                    });
                    return EMPTY;
                })
            );
    }
}
